import {
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
  NextPage,
} from 'next';
import { GetServerSideProps } from 'next/types';
import React from 'react';
import { VehicleInspection } from 'src/@carketa/vehicle_dialog/components/views/vehicle_sales_packet/VehicleSalesPacket';
import BlankLayout from 'src/@core/layouts/BlankLayout';
import { prisma } from 'src/server/db/client';
import { hasOrgFeatureFlag } from 'src/server/common/permissions';

const VehicleInspectionPageView: NextPage<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = ({ vin, inspectionId, pdfMode, hasSalesPacket }) => {
  return (
    <BlankLayout>
      <div className="max-sm:m-0 sm:mb-20 sm:mx-20 sm:mt-10">
        <VehicleInspection
          vin={vin}
          inspectionId={inspectionId}
          pdfMode={pdfMode}
          hasSalesPacket={hasSalesPacket}
        />
      </div>
    </BlankLayout>
  );
};

export default VehicleInspectionPageView;

export const getServerSideProps: GetServerSideProps = async (
  ctx: GetServerSidePropsContext
) => {
  const vehicle = await prisma.vehicles.findFirst({
    select: {
      organization: {
        select: {
          id: true,
          feature_flags: true,
        },
      },
    },
    where: {
      vin: ctx.query.vin as string,
      type: 'inventory',
      deleted_at: null,
    },
  });

  const hasSalesPacket = await hasOrgFeatureFlag({
    organization: vehicle?.organization as {
      id: string;
      feature_flags: string[];
    },
    feature_flags: ['sales_packet'],
  });

  if (hasSalesPacket)
    return {
      redirect: {
        destination: `/sales-packet/${ctx.query.vin}`,
        permanent: false,
      },
    };

  return {
    props: {
      vin: ctx.query.vin,
      inspectionId: ctx.query.inspectionId || null,
      pdfMode: ctx.query.pdfMode ?? false,
      hasSalesPacket: hasSalesPacket
    },
  };
};
